export const SANDBOX_BUTTON_DESCRIPTION =
  'Create simple front-end prototypes where all the code runs in your browser';
export const DEVBOX_BUTTON_DESCRIPTION =
  'Build and share standalone projects of any size in our Cloud Development Environment.';
export const IMPORT_BUTTON_DESCRIPTION =
  'Run any branch instantly, create and review PRs in our Cloud Development Environment.';

// Exception for author
export const CODEIUM_ID = 'yrqw7k';

export const FEATURED_IDS = [
  '9qputt', // react (vite + ts)
  '3l5fg9', // javascript-devbox
  'kmwy42', // html-css-devbox
  'fxis37', // next
  CODEIUM_ID, // codeium
  'pb6sit', // vue
  'angular', // angular
  'hsd8ke', // docker
  'in2qez', // python
];
